import { useState, useEffect, useContext } from "react";
import React from "react";
import {
  SvgLiveStreamEmpty,
  SvgArrowRight,
  SvgCamera,
  SvgIPSpeakers,
  SvgNvr,
  SvgRectAI,
  SvgRectAIPlus,
  SvgForward,
  SvgCog6ToothEmpty,
  SvgPtz,
  SvgMonitorOnDuty,
  SvgMonitorOffDuty,
  SvgMonitorDisabled,
  SvgDealerAutomation,
  SvgRelease,
} from "ui/svgs";
import { Signal } from "webrtc-player/common/signal";
import { isCameraExpired } from "lib/utils";
import { AuthContext } from "context/AuthContext";
import { personKey, vehicleKey, onMotorVehicleKey } from "lib/constants";
import { Fetcher } from "swr";
import { fetchWithParams } from "lib/fetcher";
import { useNavigate, useParams } from "react-router-dom";
import clsx from "clsx";
import { PlusIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "antd";
import { Popover } from "react-tiny-popover";
import { Popover as PopoverAntd } from "antd";
import Cookies from "js-cookie";
import moment from "moment";
import { SideviewContext } from "context/SideviewContext";
import { CameraInfo, CamerasRes } from "lib/types";
import useUncachedSWR from "lib/uncachedSWR";
import useWsSender from "lib/wsSenderHook";
import LiveStreamModal from "./live-stream-modal";
import { showToast } from "ui/components/common";
import CustomForward from "./customForward";
import MonitoringModal from "./monitoringModal";
import CameraNameWithSnapshotPop from "./camera-name-with-snapshot-pop";
import { StreamingCameraType } from "lib/types";
import AutomationModal from "ui/automation/automationModal";
import { AutomationContext } from "context/AutomationContext";
import { SignalContext } from "context/SignalContext";
import "./nvr-item.scss";
import { getCameraRule } from "pages/service";
import { getNvrById, useWSService } from "./service";
import _ from "lodash";

let liveCamera = null;
let selectedCamera = null;

const enum MonitorStatus {
  MonitorStatus_OFF_DUTY = "enable_off_duty",
  MonitorStatus_DISABLED = "disabled",
  MonitorStatus_ON_DUTY = "enable_on_duty",
}

export default function NvrItem({
  siteId,
  objData,
  reCalcParentHeight,
}: {
  siteId: string;
  objData: any;
  reCalcParentHeight: (height: number) => void;
}) {
  const { orgid } = useParams();

  const orgId = orgid!;
  const navigate = useNavigate();
  const { sendWsRequest } = useWsSender();
  const { sessionId } = useContext(SignalContext);
  const { setStreamingCamera, setResetedData, setSupportedEventTypes } =
    useContext(AutomationContext);
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState("0px");
  const [shouldFetch, setshouldFetch] = useState(false);
  const [isAddDevicePopoverOpen, setIsAddDevicePopoverOpen] = useState(false);
  const refContent = React.useRef<HTMLDivElement>(null);
  const { user } = useContext(AuthContext);
  const [wsRequestIds, setWsRequestIds] = useState(new Set());
  const { setOpenPanel, setViewData } = useContext(SideviewContext);
  const [showLiveStream, setShowLiveStream] = useState(false);
  const [monitorModalVisible, setMonitorModalVisible] = useState(false);
  const [automationModalVisible, setAutomationModalVisible] = useState(false);
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const { upgradeEdge } = useWSService();
  const timerIdRef = React.useRef(null);

  useEffect(() => {
    return () => {
      if (timerIdRef.current) {
        clearTimeout(timerIdRef.current);
      }
    };
  }, []);

  function toggleAccordion() {
    setActive(!active);
    if (refContent.current != null && refContent.current != undefined) {
      console.log(
        "toggleAccordion scrollHeight = ",
        refContent.current.scrollHeight,
      );
    }
  }
  const rotate = active ? "rotate(90deg)" : "rotate(0)";
  function handleClick() {
    if (!data) {
      setshouldFetch(true);
      toggleAccordion();
    } else {
      toggleAccordion();
    }
  }
  const deviceForward = async (deviceType: string, deviceId: number) => {
    //start loading
    setWsRequestIds((state) => {
      state.add(deviceId);
      return new Set(state);
    });
    try {
      const res: any = await sendWsRequest(
        "device.remote_service.open",
        {
          deviceOpenRemoteService: {
            deviceId: deviceId.toString(),
            deviceType,
          },
        },
        { orgId: Number(orgId) },
      );
      const query =
        "?expiredAt=" +
        res.deviceOpenRemoteServiceReply.cookie.expiredAt +
        "&name=" +
        res.deviceOpenRemoteServiceReply.cookie.name +
        "&value=" +
        res.deviceOpenRemoteServiceReply.cookie.value;
      window.open(
        "https://" + res.deviceOpenRemoteServiceReply.domain + query,
        "_blank",
      );
    } catch (e) {
      showToast(1, "There was a problem forwarding nvr. Error:" + e);
    } finally {
      //end loading
      setWsRequestIds((state) => {
        state.delete(deviceId);
        return new Set(state);
      });
    }
  };

  const fetcher: Fetcher<CamerasRes, string> = ([url, token, orgId]) =>
    fetchWithParams(url, token, orgId);
  const params = `?siteId=${siteId}&nvrId=${objData.id}&page.limit=100&withUp=true`;
  const { data, isLoading } = useUncachedSWR(
    shouldFetch ? [`/camera/cameras${params}`, user.token, orgId] : null,
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );
  const { data: speakers, isLoading: speakersIsLoading } = useUncachedSWR(
    shouldFetch ? [`/speaker/speakers${params}`, user.token, orgId] : null,
    ([url, token, orgId]) => fetchWithParams(url, token, orgId),
    {
      revalidateOnFocus: false,
    },
  );
  useEffect(() => {
    if (data && speakers) {
      setTimeout(() => {
        setHeight(!active ? "0px" : `${refContent.current.scrollHeight}px`);
        reCalcParentHeight(refContent.current.scrollHeight);
      });
    }
  }, [data, speakers, active]);

  async function handleClickCameraAutomation(objCamera) {
    const res = await getCameraRule(orgId, objCamera?.id, true);
    if (res.status !== 200) {
      showToast(1, "Failed to get camera rule. Please try again");
      return;
    }
    const cameraRule = res.data?.data;
    //const dataCredentials = await getCredentials([objCamera.nvrId]);
    const token = Cookies.get("token");
    const result = await Signal.getTurns(
      token,
      +orgId,
      cameraRule.nvrId,
      sessionId,
    );
    if (result.err) {
      throw new Error(result.err.message);
    }
    const dataCredentials = result.ret;

    const camera: StreamingCameraType = {
      devId: cameraRule.deviceId.toString(),
      type: cameraRule.type,
      orgId: orgId,
      nvrId: cameraRule.nvrId.toString(),
      cameraId: cameraRule.cameraId.toString(),
      cameraName: cameraRule.name,
      token: token!,
      turn: dataCredentials?.turn,
      rtcToken: dataCredentials?.token,
      sessionId: sessionId,
      cameraMac: cameraRule.macAddress,
      remoteIndex: cameraRule.remoteIndex.toString(),
      streamId: "0",
      status: cameraRule.status,
      siteId: siteId,
      capabilities: cameraRule.capabilities,
    };
    // Sort detections by index
    //objCamera.detections.sort((a, b) => a.index - b.index);
    cameraRule?.algorithms?.forEach((alg) => {
      alg.detections.sort((a, b) => a.index - b.index);
    });

    const customOrder = [personKey, vehicleKey, onMotorVehicleKey];
    cameraRule.supportedEventTypes.sort(
      (a, b) => customOrder.indexOf(a) - customOrder.indexOf(b),
    );
    if (
      cameraRule.actions.length === 0 ||
      !cameraRule.actions[0]?.notifiers?.ownerNotifier?.types
    ) {
      cameraRule.actions = [
        {
          notifiers: {
            ownerNotifier: {
              types: [],
            },
          },
        },
      ];
    }
    setStreamingCamera(camera);
    setSupportedEventTypes(cameraRule.supportedEventTypes);
    setResetedData({
      alertSchedules: cameraRule.schedules,
      algorithms: cameraRule.algorithms,
      actions: cameraRule.actions,
      note: cameraRule.note,
      advancedAISetting: {
        enableAgi: cameraRule?.aiSettings?.enableAgi || false,
        enableCase: cameraRule?.aiSettings?.enableCase || false,
        enableNonMotor: cameraRule?.aiSettings?.enableNonMotor || false,
        enablePerson: cameraRule?.aiSettings?.enablePerson || false,
        enableVehicle: cameraRule?.aiSettings?.enableVehicle || false,
        virtualGuard: {
          cameraSpeakerEnabled:
            cameraRule?.aiSettings?.virtualGuard?.cameraSpeakerEnabled || false,
          ipSpeakerEnabled:
            cameraRule?.aiSettings?.virtualGuard?.ipSpeakerEnabled || false,
          speakerIds: cameraRule?.aiSettings?.virtualGuard?.speakerIds ?? [],
          languages: cameraRule?.aiSettings?.virtualGuard?.languages ?? [],
          pitch: cameraRule?.aiSettings?.virtualGuard?.pitch || "Medium",
          volume: cameraRule?.aiSettings?.virtualGuard?.volume || "Medium",
          rate: cameraRule?.aiSettings?.virtualGuard?.rate || "Medium",
        },
        aiAlgoSettings: cameraRule?.aiSettings?.aiAlgoSettings,
      },
    });
    setAutomationModalVisible(true);
  }

  const hasPrerequisiteError =
    objData?.devicePrerequisite?.prerequisiteList?.some(
      (e) => e.level === "error",
    );

  const upgradable = () => {
    if (
      ["success", "failed", "empty"].includes(objData.upgrade.upgradingState) &&
      objData.status === "online"
    ) {
      const nvr_edge = objData.upgrade?.services?.find(
        (item) => item.service === "nvr_edge",
      );
      if (nvr_edge && nvr_edge.upgradable === "need_upgrade") {
        return true;
      }
    }
    return false;
  };

  const upgrade = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setUpgradeLoading(true);

    try {
      await upgradeEdge(orgId, objData.id);
      setUpgradeLoading(false);
      const queryNvr = async () => {
        const data = await getNvrById(objData.id, orgId);
        const nvr = data.data.data;
        if (!["upgrading", "initial"].includes(nvr.upgrade.upgradingState)) {
          if (nvr.upgrade.upgradingState === "success") {
            showToast(0, "Upgrade result:" + nvr.upgrade.upgradingState);
            navigate("/dashboard/customers");
          } else
            showToast(
              1,
              "There was a problem of upgrading. Result:" +
                nvr.upgrade.upgradingState,
            );
        } else {
          timerIdRef.current = setTimeout(() => queryNvr(), 5000);
        }
      };
      queryNvr();
    } catch (e) {
      setUpgradeLoading(false);
      showToast(1, "There was a problem of upgrading. Please try again.");
    }
  };
  const monitoringPopover = (camera: CameraInfo) => {
    const monitoringInfo =
      camera?.cloudCapabilities?.funcsEnabled?.goods_unit_type_monitoring;
    const disabled = !monitoringInfo?.enable;

    let popCotent = "";
    if (!disabled) {
      switch (camera?.monitoringStatus) {
        case MonitorStatus.MonitorStatus_OFF_DUTY:
          popCotent = "Monitoring Off Duty. Click to Manage";
          break;
        case MonitorStatus.MonitorStatus_DISABLED:
          popCotent = "Monitoring Disabled. Click to Enable.";
          break;
        case MonitorStatus.MonitorStatus_ON_DUTY:
        default:
          popCotent = "Monitoring On Duty. Click to Manage";
      }
    } else {
      popCotent = monitoringInfo?.reason;
    }
    let statusIcon;
    if (!disabled) {
      const monitoringStatus = camera?.monitoringStatus;
      switch (monitoringStatus) {
        case MonitorStatus.MonitorStatus_OFF_DUTY:
          statusIcon = (
            <SvgMonitorOnDuty width="24" className="fill-[#F73D2F]" />
          );
          break;
        case MonitorStatus.MonitorStatus_DISABLED:
          statusIcon = (
            <SvgMonitorDisabled width="24" className="fill-[#F73D2F]" />
          );
          break;
        case MonitorStatus.MonitorStatus_ON_DUTY:
        default:
          statusIcon = (
            <SvgMonitorOnDuty width="24" className="fill-[#179954]" />
          );
      }
    } else {
      statusIcon = (
        <SvgMonitorDisabled width="24" className="fill-[#222222] opacity-25" />
      );
    }

    return (
      <PopoverAntd content={popCotent}>
        <button
          className={clsx(" text-neutral-500 p-1 fill-neutral-500 ml-1", {
            "rounded-full hover:bg-neutral-200": !disabled,
          })}
          disabled={disabled}
          onClick={(event) => {
            event.preventDefault();
            setMonitorModalVisible(true);
            selectedCamera = camera;
          }}
        >
          {statusIcon}
        </button>
      </PopoverAntd>
    );
  };

  return (
    <>
      <div
        className="py-3.5 w-full bg-zinc-50 cursor-pointer flex justify-between group items-center text-left"
        onClick={handleClick}
      >
        <div className="flex items-center w-3/12 min-w-[25%] 2xl:w-4/12 2x:min-w-[33.33%]  pr-3 justify-between">
          <div className="flex items-center">
            <SvgArrowRight
              width="22"
              style={{ transform: rotate, transition: "all 0.2s linear" }}
              className={"fill-neutral-500 mr-1 flex-shrink-0"}
            />
            <span
              className={clsx(
                "font-semibold break-all",
                hasPrerequisiteError
                  ? "fill-[#F73D2F] text-[#F73D2F]"
                  : "fill-[#717171] text-[#717171]",
              )}
            >
              <SvgNvr width="22" className={"inline-block mr-2"} />
              {objData.name}
            </span>
          </div>
          <div className="flex items-center ">
            {(isLoading || speakersIsLoading) && (
              <div
                className="text-blue-500 ml-auto inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status"
              ></div>
            )}
            <span className=" break-all text-[#222222]">
              {objData.bandwidthLimit && objData.bandwidthLimit / 1000 + "Mbps"}
            </span>
          </div>
        </div>
        <div className="w-[16.67%] 2xl:w-1/12 min-w-[16.67%] 2xl:min-w-[8.33%] pr-[41px] flex items-center">
          <div className="rounded-2xl text-base text-center2">
            <span
              className={clsx(
                "inline-block w-3 h-3 rounded-full mr-1",
                objData.status == "online" ? "bg-emerald-400" : "bg-[#F73D2F]",
              )}
            ></span>
          </div>
          {upgradable() && (
            <Tooltip title="NVR Upgrade">
              <button
                className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1"
                onClick={upgrade}
              >
                {upgradeLoading ? (
                  <div
                    className=" text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                    role="status"
                  ></div>
                ) : (
                  <SvgRelease className="fill-[#3E83F6]" width="20" />
                )}
              </button>
            </Tooltip>
          )}
        </div>
        <div className="w-3/12 min-w-[25%] pr-1">{objData.model}</div>
        <div className="w-1/12 min-w-[8.33%] pr-1">{objData.manufacturer}</div>
        <div className="w-[12.5%] min-w-[12.5%] pr-1"></div>
        <div className="w-[12.5%] min-w-[12.5%] text-right">
          <div className="invisible2 group-hover:visible flex items-center justify-end flex-wrap">
            <Popover
              isOpen={isAddDevicePopoverOpen}
              positions={["bottom", "left", "right", "top"]}
              onClickOutside={() => setIsAddDevicePopoverOpen(false)}
              content={
                <div
                  className="bg-white rounded-2xl py-2 w-[153px] shadow overflow-hidden"
                  onMouseOut={() => setIsAddDevicePopoverOpen(false)}
                  onMouseOver={() => setIsAddDevicePopoverOpen(true)}
                >
                  <button
                    className="block w-full hover:bg-[#DCE7FD] h-12 text-neutral-800"
                    onClick={() => {
                      navigate(
                        `/dashboard/customers/${orgId}/sites/${siteId}/nvrs/${objData.id}/cameras/create`,
                      );
                    }}
                  >
                    Add Camera
                  </button>
                  <button
                    className="block w-full hover:bg-[#DCE7FD] h-12 text-neutral-800"
                    onClick={() => {
                      navigate(
                        `/dashboard/customers/${orgId}/sites/${siteId}/nvrs/${objData.id}/ip-speakers`,
                        {
                          state: {
                            nvrName: objData.name,
                          },
                        },
                      );
                    }}
                  >
                    Add IP Speaker
                  </button>
                </div>
              }
            >
              <div>
                <Tooltip title="Add Device">
                  <button
                    className="hover:bg-neutral-200 rounded-full p-1 text-neutral-500 disabled:opacity-50 disabled:hover:bg-transparent"
                    disabled={hasPrerequisiteError}
                    onClick={(e) => {
                      setIsAddDevicePopoverOpen(true);
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <PlusIcon className="h-6" />
                  </button>
                </Tooltip>
              </div>
            </Popover>
            <Tooltip title="NVR Forward">
              <button
                className="hover:bg-neutral-200 rounded-full text-neutral-500 p-2 fill-neutral-500 "
                disabled={wsRequestIds?.has(objData.id)}
                onClick={(event) => {
                  event.preventDefault();
                  deviceForward("nvr", objData.id);
                }}
              >
                {wsRequestIds?.has(objData.id) ? (
                  <div
                    className="ml-1 text-neutral-800  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                    role="status"
                  ></div>
                ) : (
                  <>
                    <SvgForward width="16" />
                  </>
                )}
              </button>
            </Tooltip>
            <Tooltip title="Custom Forward">
              <button
                className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1 fill-neutral-500 "
                disabled={wsRequestIds?.has(objData.id)}
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                {wsRequestIds?.has(objData.id) ? (
                  <div
                    className="ml-1 text-neutral-800  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                    role="status"
                  ></div>
                ) : (
                  <>
                    <CustomForward
                      deviceId={objData.id}
                      orgId={objData.orgId}
                    />
                  </>
                )}
              </button>
            </Tooltip>
            <Tooltip title="NVR Settings">
              <button
                className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const sideviewData = {
                    type: "edit-nvr",
                    title: "NVR Details",
                    orgId: orgId,
                    siteId: objData.siteId,
                    nvrId: objData.id,
                    objData: objData,
                  };
                  setViewData(sideviewData);
                  setOpenPanel(true);
                }}
              >
                <SvgCog6ToothEmpty width="24" />
              </button>
            </Tooltip>
          </div>
        </div>
      </div>
      <div
        ref={refContent}
        className="overflow-hidden block pb-2"
        style={{ maxHeight: `${height}`, transition: "max-height 0.4s ease" }}
      >
        {data?.page?.total == 0 && speakers?.page.total == 0 && (
          <div className="text-sm text-center text-neutral-400">
            No Cameras or IP Speakers
          </div>
        )}

        {speakers?.data?.map((data: any) => (
          <div
            key={data.id}
            className="py-3.5 flex justify-between text-left group items-center"
          >
            <div className="flex justify-between pl-8 w-3/12 min-w-[25%] 2xl:w-4/12 2x:min-w-[33.33%] items-center  pr-1">
              <span className="flex justify-center">
                <SvgIPSpeakers
                  width="22"
                  className="fill-neutral-500 inline-block mr-1"
                />
                <span className="font-semibold">{data.name}</span>
              </span>
            </div>
            <div className="break-allw-[16.67%] 2xl:w-1/12 min-w-[16.67%] 2xl:min-w-[8.33%] pr-[41px]">
              <div className="rounded-2xl text-base">
                <span
                  className={clsx(
                    "inline-block w-3 h-3 rounded-full mr-1",
                    data.status == "online" ? "bg-emerald-400" : "bg-red-500",
                  )}
                ></span>
              </div>
            </div>
            <div className="w-3/12 break-all min-w-[25%] pr-1">
              {data.model}
            </div>
            <div className="w-1/12 break-all min-w-[8.33%] pr-1">
              {data.manufacturer}
            </div>
            <div className="w-[12.5%] min-w-[12.5%%] pr-1"></div>
            <div className="w-[12.5%] break-all">
              <div className="invisible2 group-hover:visible flex items-center justify-end flex-wrap">
                <Tooltip title="Speaker Forward">
                  <button
                    className="hover:bg-neutral-200 rounded-full text-neutral-500 p-2 fill-neutral-500"
                    disabled={wsRequestIds?.has(data.id)}
                    onClick={(event) => {
                      event.preventDefault();
                      deviceForward("ip_speaker", data.id);
                    }}
                  >
                    {wsRequestIds?.has(data.id) ? (
                      <div
                        className="ml-1 text-neutral-800  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                        role="status"
                      ></div>
                    ) : (
                      <SvgForward width="17" />
                    )}
                  </button>
                </Tooltip>
                <Tooltip title="Speaker Settings">
                  <button
                    className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1 fill-neutral-500"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      console.log("ip speaker setting clicked", data);
                      const sideviewData = {
                        type: "edit-ipspeaker",
                        title: "IP Speaker Details",
                        orgId: orgId,
                        siteId: objData.siteId,
                        cameraId: data.id,
                        objData: data,
                      };
                      setViewData(sideviewData);
                      setOpenPanel(true);
                    }}
                  >
                    <SvgCog6ToothEmpty width="22" />
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>
        ))}

        {data && data.data && data.page.total > 0 && (
          <>
            {data.data.map((data) => {
              const hasErr = data?.devicePrerequisite?.prerequisiteList?.some(
                (e) => e.level === "error",
              );
              const hasWarning =
                data?.devicePrerequisite?.prerequisiteList?.some(
                  (e) => e.level === "warn",
                );
              return (
                <div
                  key={data.id}
                  className="py-3.5 flex justify-between text-left group items-center"
                >
                  <div className="flex justify-between pl-8 min-w-[25%] 2xl:w-4/12 2x:min-w-[33.33%]  items-center pr-3">
                    <span className="flex justify-center">
                      <SvgCamera
                        width="19"
                        className={clsx(
                          "inline-block mr-1",
                          hasErr
                            ? " fill-red-600"
                            : hasWarning
                              ? " fill-yellow-600"
                              : " fill-neutral-500",
                        )}
                        style={{
                          color: hasErr
                            ? "#dc2626"
                            : hasWarning
                              ? "#eab308"
                              : "#717171",
                        }}
                      />
                      <CameraNameWithSnapshotPop camera={data} />
                    </span>
                    <span className="flex">
                      <span>
                        {data.capabilities.umd && (
                          <SvgRectAI width="20" className="" />
                        )}
                      </span>
                      <span>
                        {data.capabilities.sip && (
                          <SvgRectAIPlus width="20" className="" />
                        )}
                      </span>
                      <span>
                        {data.capabilities.ptz && (
                          <SvgPtz width="20" className="fill-neutral-800" />
                        )}
                      </span>
                    </span>
                  </div>
                  <div
                    className="break-all w-[16.67%] 2xl:w-1/12 min-w-[16.67%] 2xl:min-w-[8.33%] pr-1"
                    style={{
                      display: "flex",
                      // width: "10%",
                      alignItems: "center",
                    }}
                  >
                    <div className="rounded-2xl text-base text-center2 ">
                      <span
                        className={clsx(
                          "inline-block w-3 h-3 rounded-full mr-1",
                          data.status == "online"
                            ? "bg-emerald-400"
                            : "bg-red-500",
                        )}
                      ></span>
                    </div>
                    {monitoringPopover(data)}
                  </div>
                  <div className="w-3/12 min-w-[25%] break-all pr-1">
                    {data.model}
                  </div>
                  <div className="w-1/12 min-w-[8.33%] break-all pr-1">
                    {data.manufacturer}
                  </div>
                  <div className="w-[12.5%] min-w-[12.5%] break-all pr-1">
                    {data.expiredAt
                      ? "Exp " +
                        moment(parseInt(data.expiredAt)).format("YYYY/MM/DD")
                      : "-"}
                  </div>
                  <div className="w-[12.5%]  break-all text-right">
                    <div className="invisible2 group-hover:visible flex items-center justify-end flex-wrap">
                      <Tooltip title="Configuration">
                        <button
                          className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1 fill-[#717171]"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickCameraAutomation(data);
                          }}
                        >
                          <SvgDealerAutomation width="24" />
                        </button>
                      </Tooltip>
                      <Tooltip title="Camera Forward">
                        <button
                          className="hover:bg-neutral-200 rounded-full text-neutral-500 p-2 fill-[#717171]"
                          disabled={wsRequestIds?.has(data.id)}
                          onClick={(event) => {
                            event.preventDefault();
                            deviceForward("ip_camera", data.id.toString());
                          }}
                        >
                          {wsRequestIds?.has(data.id) ? (
                            <div
                              className="ml-1 text-neutral-800  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                              role="status"
                            ></div>
                          ) : (
                            <>
                              <SvgForward width="16" />
                            </>
                          )}
                        </button>
                      </Tooltip>
                      {user?.organization?.enableMonitoring && (
                        <Tooltip title="Monitor">
                          <button
                            className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1 fill-[#717171]"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();

                              liveCamera = data;
                              setShowLiveStream(true);
                            }}
                          >
                            <SvgLiveStreamEmpty />
                          </button>
                        </Tooltip>
                      )}
                      <Tooltip title="Camera Settings">
                        <button
                          className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1 fill-neutral-800"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const sideviewData = {
                              type: "edit-ipc",
                              title: "Camera Settings",
                              orgId: orgId,
                              siteId: objData.siteId,
                              cameraId: data.id,
                              objData: data,
                            };
                            setViewData(sideviewData);
                            setOpenPanel(true);
                          }}
                        >
                          <SvgCog6ToothEmpty width="22" />
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
      <LiveStreamModal
        visible={showLiveStream}
        camera={liveCamera}
        onClose={() => setShowLiveStream(false)}
      />
      <MonitoringModal
        visible={monitorModalVisible}
        data={selectedCamera}
        onClose={() => {
          setMonitorModalVisible(false);
        }}
        onRefresh={() => {
          setshouldFetch((state) => !state);
          setTimeout(() => setshouldFetch(true));
        }}
      />
      <AutomationModal
        visible={automationModalVisible}
        onClose={() => setAutomationModalVisible(false)}
      />
    </>
  );
}
